export function getImageUrl(images, quality = 200) {
    const image = getImageBySize(images, quality);
    return image?.src ?? null;
}
export function getImageBySize(images, quality = 200) {
    const image = images?.find(({ url }) => !!url);
    const variant = quality === "full"
        ? undefined
        : [...(image?.variants ?? [])]
            .filter(({ width }) => width >= quality)
            .sort((a, b) => a.width - b.width)[0];
    const credit = image?.meta?.find((entry) => entry.key === "creator")?.value;
    const description = image?.caption?.plainText?.join("\n");
    const altText = image?.altText ?? "";
    const src = variant?.url ?? image?.url;
    const width = variant?.width ?? image?.width;
    const height = variant?.height ?? image?.height;
    const aspectRatio = width && height && width > 0 && height > 0 ? width / height : undefined;
    return {
        src,
        credit,
        description,
        altText,
        width,
        height,
        aspectRatio,
    };
}
